export type Validators = [string, ...any[]][]
export type ValidateFields = { fieldName?: string; fieldAlias?: string, value?: string; validators: Validators}[]
export type ValidateRes = {
  hasErr?: boolean
  errMsgs?: string[]
  errDetail?: ErrDetail
}

type ErrDetail = {
  [key: string ]: {
    [type: string]: string
  }
}
export class FormValidator {
  [x: string]: any;
  required(value: string): string | undefined {
    const validateValue = this.isObject(value) ? this.checkObjectUndefind(value) : value?.toString()?.trim()
    if (!validateValue) {
      return lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80058', '该字段为必填项');
    }
  }

  isObject(value: any){
    return typeof value === 'object' && value !== null
  }
  checkObjectUndefind(obj: any) {
    for(var key in obj){
      if(obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== null){
        return true
      }
    }
    return false
  }

  type(value: string, type: "email" | "number" | "date"): string | undefined {
    switch (type) {
      case "email":
        if (value && !/^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value)) {
          return lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8005C', '请输入有效的邮箱地址');
        }
        break;
      case "number":
        if (value && isNaN(Number(value))) {
          return lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80060', '请输入有效的数字');
        }
        break;
      case "date":
        if (value && isNaN(Date.parse(value))) {
          return lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80059', '请输入有效的日期');
        }
        break;
      default:
        break;
    }
  }

  length(value: string, min: number, max: number): string | undefined {
    if (value && (value.length < min)) return `${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8005D', '该字段长度应大于')}${min}`;
    if (value && (value.length > max)) return `${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8005E', '该字段长度应小于')}${max}`;
  }

  format(value: string, regex: RegExp, message: string): string | undefined {
    if (value && !regex.test(value)) {
      return message;
    }
  }

  range(value: number, min: number, max: number): string | undefined {
    if (value && (value < min)) return `${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8005A', '该字段应大于')}${min}`;
    if (value && (value > max)) return `${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8005B', '该字段应小于')}${max}`;
  }

  confirm(value: string, originalValue: string): string | undefined {
    if (value !== originalValue) {
      return lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8005F', '确认值与原始值不匹配');
    }
  }

  security(value: string): void {
    // 进行安全性验证，例如防止跨站脚本攻击等
    console.log(value)
  }

  validate(fields: ValidateFields): ValidateRes {
    const errMsgs = [];
    const errDetail: ErrDetail = {}

    for (let field of fields) {
      const { fieldName, value, validators, fieldAlias } = field;
      for (let validator of validators) {
        const [type, ...args] = validator;
        const errMsg = this[type](value, ...args);
        if (errMsg) {
          errMsgs.push(`${fieldName}: ${errMsg}`)
          if(!fieldAlias) break
          if (!errDetail[fieldAlias]) errDetail[fieldAlias] = {}
          errDetail[fieldAlias]['fieldName'] = fieldName|| ''
          errDetail[fieldAlias][type] = errMsg
          // break;
        }
      }
    }

    const validateRes: ValidateRes = {}
    const hasErr = !(Object.keys(errMsgs).length === 0);
    validateRes.hasErr = hasErr
    validateRes.errMsgs = errMsgs
    validateRes.errDetail = errDetail
    return validateRes
  }

  getErrors(): Record<string, string> {
    return this.errors;
  }
}

/* const validator = new FormValidator();

const fields = [
  { name: "username", value: "John", validators: [["required"]] },
  { name: "password", value: "12345", validators: [["required"], ["length", 6, 20]] },
  { name: "email", value: "johnexample.com", validators: [["required"], ["type", "email"]] },
];

const isValid = validator.validate(fields);

if (isValid) {
  // 表单提交代码
} else {
  const errors = validator.getErrors();
  // 显示错误信息
}
*/
